import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexDetailComponent } from './index-detail.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
  ],
  declarations: [IndexDetailComponent],
  entryComponents: [IndexDetailComponent]
})
export class IndexDetailModule { }
